module.exports = __webpack_public_path__ + "jtails-build/img/banner@1.376ffe5b.jpg";